import React from 'react'
import classnames from 'classnames/bind'

import CopyIcon from 'components/icons/CopyIcon'
import CheckMark from 'components/icons/CheckMark'
import useCopyToClipboard from 'hooks/useCopyToClipboard'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export function CopyButton({ content }) {
  const [_, copyToClipboard, copied] = useCopyToClipboard()

  return (
    <button
      onClick={() => copyToClipboard(content)}
      className={cx(css.copyIcon, copied && css.copied)}
      aria-label="Copy code to clipboard"
    >
      {copied ? <CheckMark theme="white" /> : <CopyIcon />}
    </button>
  )
}
